export const SET_SEARCH_KIND = 'SET_SEARCH_KIND'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const CLEAR_QUERIES = 'CLEAR_QUERIES'
